import React, { useState } from 'react';
import { Paper, Typography, Grid, Box, Divider, Alert } from '@mui/material';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

const InfoField: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <Box mb={1}>
    <Typography variant="subtitle1" fontWeight={600}>
      {label}
    </Typography>
    <Typography variant="body1">
      {value === null || value === undefined || value === '' ? 'Não informado' : value}
    </Typography>
  </Box>
);

interface Step1SimViewProps {
  data: {
    referenceYear: number;
    hasSim: boolean | null;
    simActive: boolean | null;
    simEstablishments: number | '';
    hasVet: boolean | null;
    joinedSusaf: boolean | null;
    wantsSusaf: boolean | null;
  };
}

const booleanText = (value: boolean | null) =>
  value === true ? 'Sim' : value === false ? 'Não' : 'Não informado';

const Step1SimView: React.FC<Step1SimViewProps> = ({ data }) => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Paper elevation={1} sx={{ p: 0, mb: 4 }}>
      <Box
        sx={{ px: 3, pt: 2, cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              color: "#000000DE",
              fontSize: "20px",
              mb: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {open ? (
              <KeyboardArrowUpOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            ) : (
              <KeyboardArrowDownOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            )}
            Serviço de Inspeção Municipal (SIM)
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
      </Box>

      {open && (
        <Box sx={{ p: 3 }}>
          <InfoField
            label="Ano de referência do Questionário"
            value={data.referenceYear}
          />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InfoField
                label="O município possui Serviço de Inspeção Municipal (SIM) implantado?"
                value={booleanText(data.hasSim)}
              />
            </Grid>

            {data.hasSim && (
              <>
                <Grid item xs={12}>
                  <InfoField
                    label="O Serviço de Inspeção Municipal (SIM) está ativo?"
                    value={booleanText(data.simActive)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InfoField
                    label="Quantos empreendimentos/estabelecimentos possuem SIM no município?"
                    value={
                      data.simEstablishments === '' || data.simEstablishments === null || data.simEstablishments === undefined
                        ? 'Não informado'
                        : data.simEstablishments
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <InfoField
                    label="O município possui médico veterinário exclusivo disponível para atender o SIM?"
                    value={booleanText(data.hasVet)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InfoField
                    label="O município fez adesão ao Sistema Unificado Estadual de Sanidade Agroindustrial Familiar e de Pequeno Porte - SUSAF/MT?"
                    value={booleanText(data.joinedSusaf)}
                  />

                </Grid>
                <Grid item xs={12}>
                  <InfoField
                    label="O município tem interesse em aderir ao SUSAF/MT?"
                    value={booleanText(data.wantsSusaf)}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      )}


    </Paper>
  );
}

export default Step1SimView;
